import { AppBarComponent } from './app-bar/app-bar.component';
import { SidenavComponent } from './sidenav/sidenav.component';

export const components = [AppBarComponent, SidenavComponent];

export * from './app-bar/app-bar.component';
export * from './sidenav/sidenav.component';
